import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "../i18n/LanguageContext";
import { API } from "../lib/api";

const BASE = "https://japonyadakansertedavisi.com";
const OG_LOCALES = { tr: "tr_TR", en: "en_US", de: "de_DE", ja: "ja_JP", ru: "ru_RU", ar: "ar_SA", fr: "fr_FR", es: "es_ES" };
const HREFLANGS = ["tr", "en", "de", "ja", "ru", "ar", "fr", "es"];

export function SEO({ title, description, path = "/", image = "/og-cover.jpg", type = "website", keywords = null, noindex = false, jsonLd = null }) {
  const { lang } = useLang();
  const [override, setOverride] = useState(null);

  useEffect(() => {
    // Otonom SEO motorunun ürettiği meta iyileştirmeleri (yalnızca Türkçe varsayılan dilde uygulanır)
    if (noindex) return;
    let live = true;
    fetch(`${API}/seo/overrides?path=${encodeURIComponent(path)}`)
      .then((r) => r.json())
      .then((d) => { if (live && d && d.title) setOverride(d); })
      .catch(() => {});
    return () => { live = false; };
  }, [path, noindex]);

  const useOv = override && lang === "tr";
  const effTitle = useOv ? override.title : title;
  const effDesc = useOv ? override.description : description;
  const effKeywords = useOv && override.keywords ? override.keywords : keywords;

  const url = `${BASE}${path}`;
  const img = image.startsWith("http") ? image : `${BASE}${image}`;
  const fullTitle = effTitle.includes("2D Healthcare") ? effTitle : `${effTitle} — 2D Healthcare`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={effDesc} />
      {effKeywords && <meta name="keywords" content={effKeywords} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <link rel="canonical" href={url} />
      {HREFLANGS.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={`${url}?lang=${l}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="2D Healthcare" />
      <meta property="og:locale" content={OG_LOCALES[lang] || "tr_TR"} />
      {HREFLANGS.filter((l) => l !== lang).map((l) => (
        <meta key={l} property="og:locale:alternate" content={OG_LOCALES[l]} />
      ))}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={effDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={effDesc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((j, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>
      ))}
    </Helmet>
  );
}
